import { Component } from '@angular/core';
import { VersionCheckWorkerService } from '../services/version-check-worker-service';

@Component({
    selector: 'new-version-update-notification',
    templateUrl: './new-version-update-notification.component.html',
    styleUrls: ['./new-version-update-notification.component.scss'],
    standalone: false
})
export class NewVersionUpdateNotificationComponent {
	constructor(public versionCheckWorkerService: VersionCheckWorkerService) { }

	/**
   * Method to reload the page and activate the new version.
   */
	reloadPage(): void {
		this.versionCheckWorkerService.activateUpdate();
	}
}
